export default {"src":"/_next/static/media/BKSY.3ba863e3.svg","height":18,"width":18};